<div class="wrapper" xmlns:svg="http://www.w3.org/2000/svg">
    <div class="nest">
        <svg [attr.width]="size"
             [attr.height]="size"
        >
            <svg:g cipherSemiCircle
                   [cx]="cx"
                   [cy]="cy"
                   [r]="r"
                   [numberOfTicks]="getNumberOfTicks()"
                   [fromAngle]="minAngle"
                   [toAngle]="maxAngle"
                   [strokeWidth]="handleDiameter"
                   [color]="whiteMode ? 'white' : 'gray'"
            />
            <svg:g *ngIf="heatingSetpoint !== undefined" heatingSemiCircle [cx]="cx" [cy]="cy" [r]="r"
                   [fromAngle]="minAngle" [toAngle]="angleHeatingWithOffset"
                   [strokeWidth]="12" [color]="'heatRed'"/>
            <svg:g *ngIf="coolingSetpoint !== undefined" coolingSemiCircle [cx]="cx" [cy]="cy" [r]="r"
                   [fromAngle]="angleCoolingWithOffset" [toAngle]="maxAngle"
                   [strokeWidth]="12" [color]="'coolBlue'"/>
        </svg>
    </div>

    <div class="pos-relative">
        <div class="middle-text"
             [ngStyle]="centerClass"
             [class.temperature-cooling]="displayCoolingTemperature && !whiteMode"
             [class.temperature-heating]="displayHeatingTemperature && !whiteMode"
             [class.white-text]="whiteMode"
        >
            <div *ngIf="relativeHumidity" class="smaller-text">
                <span [ngClass]="{'dark-text': isDarkTheme()}">{{relativeHumidity}}</span>
                <mat-icon [svgIcon]="relativeHumiditySensorIcon" class="humidity-icon"></mat-icon>
            </div>
            <div>{{temperatureToDisplay}}</div>
        </div>
        <div *ngIf="heatingSetpoint !== undefined"
             class="up-down-left up-down"
             [class.center-arrow-buttons]="coolingSetpoint === undefined"
             [class.white-buttons]="whiteMode"
             [ngStyle]="centerClass">
            <button (mousedown)="increaseHeating($event)"
                    (touchstart)="increaseHeating($event)"
                    (touchend)="stopIncDecTimer()"
                    (mouseup)="stopIncDecTimer()"
                    (mouseleave)="stopIncDecTimer()"
                    [disabled]="!enabled"
                    mat-icon-button>
                <mat-icon>expand_less</mat-icon>
            </button>
            <br>
            <button (mousedown)="decreaseHeating($event)"
                    (touchstart)="decreaseHeating($event)"
                    (touchend)="stopIncDecTimer()"
                    (mouseup)="stopIncDecTimer()"
                    (mouseleave)="stopIncDecTimer()"
                    [disabled]="!enabled"
                    mat-icon-button>
                <mat-icon>expand_more</mat-icon>
            </button>
        </div>
        <div *ngIf="coolingSetpoint !== undefined"
             class="up-down-right up-down"
             [class.center-arrow-buttons]="heatingSetpoint === undefined"
             [class.white-buttons]="whiteMode"
             [ngStyle]="centerClass"
        >
            <button (mousedown)="increaseCooling($event)"
                    (touchstart)="increaseCooling($event)"
                    (touchend)="stopIncDecTimer()"
                    (mouseup)="stopIncDecTimer()"
                    (mouseleave)="stopIncDecTimer()"
                    [disabled]="!enabled"
                    mat-icon-button>
                <mat-icon>expand_less</mat-icon>
            </button>
            <br>
            <button (mousedown)="decreaseCooling($event)"
                    (touchstart)="decreaseCooling($event)"
                    (touchend)="stopIncDecTimer()"
                    (mouseup)="stopIncDecTimer()"
                    (mouseleave)="stopIncDecTimer()"
                    [disabled]="!enabled"
                    mat-icon-button>
                <mat-icon>expand_more</mat-icon>
            </button>
        </div>
    </div>


    <div *ngIf="coolingSetpoint !== undefined"
         class="circle-handle circle-handle-blue"
         [class.circle-handle-disabled]="!enabled"
         circularSliderHandle
         [diameter]="size"
         [(angle)]="angleCooling"
         [angleMin]="minAngleCooling"
         [angleMax]="maxAngleCooling"
         [circleRadius]="r"
         [handleDiameter]="handleDiameter"
         [cx]="cx"
         [cy]="cy"
         [rightToLeft]="true"
         [handleOriginTransformX]="handleOriginTransformX"
         [handleOriginTransformY]="handleOriginTransformY"
         (movingStart)="coolingHandleMovingStarted()"
         (movingEnd)="coolingHandleMovingFinished()"
         [handleName]="HeatingCooling.COOLING"
         [enabled]="enabled"
    >
        <span [class.handle-disabled]="!enabled">{{coolingSetpoint}}</span>
    </div>

    <div *ngIf="heatingSetpoint !== undefined"
         class="circle-handle circle-handle-red"
         [class.circle-handle-disabled]="!enabled"
         circularSliderHandle
         [diameter]="size"
         [(angle)]="angleHeating"
         [angleMin]="minAngleHeating"
         [angleMax]="maxAngleHeating"
         [circleRadius]="r"
         [handleDiameter]="handleDiameter"
         [cx]="cx"
         [cy]="cy"
         [leftToRight]="true"
         [handleOriginTransformX]="handleOriginTransformX"
         [handleOriginTransformY]="handleOriginTransformY"
         (movingStart)="heatingHandleMovingStarted()"
         (movingEnd)="heatingHandleMovingFinished()"
         [handleName]="HeatingCooling.HEATING"
         [enabled]="enabled"
    >
        <span [class.handle-disabled]="!enabled">{{heatingSetpoint}}</span>
    </div>
</div>
